import React from "react";
import { Grid, Typography, Button, TextField } from "@mui/material";

const SignaturesSection = ({ formData, handleChange, handleSignatureOpen }) => {
  return (
    <Grid container spacing={3} sx={{ mt: 2 }}>
      <Grid item xs={12}>
        <TextField
          type="datetime-local"
          label="Checklist Time"
          inputProps={{ min: new Date().toISOString().slice(0, 16) }}
          InputLabelProps={{ shrink: true }}
          fullWidth
          name="checklist_time"
          value={formData.checklist_time || ''}
          onChange={handleChange}
        />
      </Grid>
      {[
        { label: "Sig. Of Ward Duty Nurse", key: "ward_nurse_signature" },
        { label: "Sig. Of OT Charge Nurse", key: "ot_nurse_signature" },
      ].map((person) => (
        <Grid item xs={12} sm={6} key={person.key}>
          <Typography>{person.label}</Typography>
          <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen(person.key)}>
            Sign Here
          </Button>
          {formData[person.key] && (
            <img 
              src={`data:image/png;base64,${formData[person.key]}`} 
              alt="Signature" 
              style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px' }} 
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default SignaturesSection;
